module.exports = __webpack_public_path__ + "static/media/retorno-america.1d0a84f6.webp";